// packages/shared-hooks/src/clients/useRestoreClient.ts
//
// `POST /clients/:id/restore` — unarchive. Backend rejects when the
// unique slots (`nameNormalized`, contact phone, legal-entity inn) are
// claimed by a concurrently-created peer; surface that 409 verbatim.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientDetailSchema, type ClientDetail } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useRestoreClient(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientDetail, unknown, void>({
    mutationFn: () =>
      client.post<ClientDetail>(`/clients/${id}/restore`, undefined, {}, ClientDetailSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(id) });
    },
  });
}
